import { ReactNode } from 'react';

export type InfoBoxVariant = 'default' | 'warning' | 'danger';

export type InfoBoxProps = {
  variant: InfoBoxVariant;
  /** 16px stroke icon, see `components/svgs`. */
  icon?: ReactNode;
  title?: string;
  children: ReactNode;
  /** Trailing action, e.g. a ghost button. */
  action?: ReactNode;
  className?: string;
};

const variantClasses: Record<InfoBoxVariant, string> = {
  default:
    'border-design-secondary-black bg-muted-white dark:bg-design-black-accent',
  warning: 'border-yellow bg-yellow text-design-black',
  danger: 'border-darker-red bg-darker-red text-white',
};

const InfoBox = ({
  variant,
  icon,
  title,
  children,
  action,
  className,
}: InfoBoxProps) => (
  <div
    role="note"
    className={`flex items-start gap-3 rounded-sm border px-4 py-3 text-sm ${variantClasses[variant]} ${className}`}
  >
    {icon && <span className="mt-0.5 shrink-0">{icon}</span>}
    <div className="flex-grow">
      {title && <div className="font-semibold">{title}</div>}
      <div>{children}</div>
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

InfoBox.defaultProps = {
  icon: undefined,
  title: undefined,
  action: undefined,
  className: '',
};

export default InfoBox;
